<template>
  <div class="home">
    <v-row class="margin-home-custom-tablet" no-gutters>
      <v-col class="margin-custom4654632 px-7" v-if="$vuetify.breakpoint.smAndDown">
        <v-row no-gutters v-if="false">
          <v-col cols="auto">
            <div class="text-chapter-2">
              <span
                class="project-description-app rewrite-font d-block margin-bottom-in-text SctoGroteskAMedium"
                style="margin-top: 0px"
                >Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Recusandae consequuntur quasi jjj
              </span>
              
              <span
                class="project-description-app rewrite-font d-block margin-bottom-in-text SctoGroteskAMedium"
                style="margin-top: 0px"
                >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi
                voluptate illum obcaecati eos quas quo explicabo pariatur
                molestias aperiam quae aliquam, soluta debitis. Nostrum placeat
                assumenda adipisci error similique voluptates.</span
              >
              
              <span
                class="project-description-app rewrite-font SctoGroteskAMedium"
                >Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Cupiditate, voluptates.</span
              >
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" class="align-self-end">
        <v-row align="end" class="position-relative" no-gutters>
          <!-- dots -->
          <div class="dots">
            <div class="dots__dot" v-bind:class="{'active': number == at}" v-for="(asset, at) in resource.content" v-bind:key="at+'dot'" @click="goToItem(at)"></div>
          </div>
          <!-- /dots -->
          <div
            class="home-div-full-screen position-relative"
            v-for="(asset, at) in resource.content"
            v-bind:key="at"
            v-bind:class="'item-'+at"
          >
            <div
              class="div-home"
              :class="{ 'full-div': asset.value.Background == null }"
              :key="at"
            >
              <!--  -->
              <template v-if="showCarousel">
                <v-carousel
                  v-model="indexSlider[at]"
                  v-bind:show-arrows="false"
                  v-bind:cycle="cycleCarouselHome"
                  hide-delimiters
                  class="cursor-custom"
                  height="100%"
                  interval="1000"
                >
                  <template v-for="(gallery, img) in asset.value.Gallery">
                    <v-carousel-item v-bind:key="img + 'imagen'" reverse-transition="animation" transition="animation">
                      <template v-if="gallery != null">
                        <v-img
                          @mouseover="cycleCarouselHome = false"
                          @mouseleave="cycleCarouselHome = true"
                          @click="
                            carouselNext(
                              at,
                              asset.value.Gallery.length,
                              indexSlider[at]
                            )
                          "
                          :src="
                            'https://www.chaptercms.actstudio.xyz/' +
                            gallery.path
                          "
                          width="100%"
                          height="100%"
                        ></v-img>
                      </template>
                    </v-carousel-item>
                  </template>
                </v-carousel>
              </template>
            </div>

            <template v-if="asset.value.Background != null">
              <div :key="at + '1'">
                <template v-if="asset.value.Background.video == true">
                  <div>
                    <video
                      id="video"
                      width="100%"
                      :height="heightVideo"
                      style="object-fit: cover"
                      autoplay
                      muted
                      loop
                    >
                      <source
                        :src="
                          'https://www.chaptercms.actstudio.xyz/storage/uploads' +
                          asset.value.Background.path
                        "
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </template>

                <template v-else>
                  <v-img
                    :src="
                      'https://www.chaptercms.actstudio.xyz/storage/uploads' +
                      asset.value.Background.path
                    "
                    class="img-home"
                  ></v-img>
                </template>
              </div>
            </template>
          </div>
          <!-- <template v-for="(asset, at) in resource.content">
            <template>
              <div class="div-home" :key="at">
                <v-carousel
                  v-model="homeImage"
                  :hide-delimiter-background="true"
                  height="100%"
                  :hide-delimiters="true"
                  :show-arrows="false"
                  class="cursor-custom"
                >
                  <v-carousel-item
                    v-for="(gallery, img) in asset.value.Gallery"
                    :key="img"
                    transition="change-transition"
                    reverse-transition="change-transition"
                  >
                    <v-img
                      :src="'https://www.chaptercms.actstudio.xyz/'+gallery.path"
                      contain
                      width="100%"
                      height="100%"
                      @click="homeImage++"
                    ></v-img>
                  </v-carousel-item>
                </v-carousel>
              </div>

              <div :key="at">
                <template v-if="asset.value.Background.video == true">
                  <div>
                    <video
                      id="video"
                      width="100%"
                      :height="heightVideo"
                      style="object-fit:cover;"
                      autoplay
                      muted
                      loop
                    >
                      <source
                        :src="'https://www.chaptercms.actstudio.xyz/storage/uploads'+asset.value.Background.path"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </template>

                <template v-else>
                  <v-img
                    :src="'https://www.chaptercms.actstudio.xyz/storage/uploads'+asset.value.Background.path"
                    width="100vw"
                    class="img-home"
                  ></v-img>
                </template>
              </div>
            </template>
          </template>-->
        </v-row>
      </v-col>
    </v-row>

    <v-row class="d-md-none">
      <v-col class="home-contact">
        <!-- date tablet -->
        <div
          v-bind:class="{
            'opacity-class': chapterCopy == false,
            animation: chapterCopy,
          }"
          style="animation-delay: 0.5s"
          class="mt-6 date-and-terms-tablet d-none d-sm-block d-md-none"
        >
          <div
            class="title-app SctoGroteskAMedium hidden-md-and-up white--text"
            id="chapterCopy"
          >
            &copy; {{ date }}
          </div>
        </div>
        <!-- date tablet -->
      </v-col>
    </v-row>

    <v-row class="d-sm-none">
      <v-col cols="12" class="home-contact">
        <ul class="ul-contact">
          <li>
            <a href="tel:528181732300" style="color: black" target="_blank">
              <span class="d-block title-app">Phone</span>
              <span class="d-block title-app">+52 (81) 81732300</span>
            </a>
          </li>
          <li>
            <a
              href="mailto:hello@chapter.mx"
              target="_blank"
              style="color: black"
            >
              <span class="d-block title-app">Email</span>
              <span class="d-block title-app">hello@chapter.mx</span>
            </a>
          </li>
          <li>
            <a
              href="https://goo.gl/maps/mr6Mk1gLTvdQS64d7"
              target="_blank"
              style="color: black"
            >
              <span class="d-block title-app">Address</span>
              <span class="d-block title-app">
                Pabellón M Benito Juárez 1102 – Nivel 24
                <br />Col. Centro, Monterrey, N.L. México. CP <br />64000
              </span>
            </a>
          </li>
        </ul>

        <div class="mt-10">
          <a href="tel:528181732300" target="_blank" style="color: black">
            <span class="d-block title-app">Instagram / @chapter_mx</span>
          </a>
          <a
            href="mailto:hello@chapter.mx"
            target="_blank"
            style="color: black"
          >
            <span class="d-block title-app">Behance / chaptermx</span>
          </a>
          <a
            href="https://goo.gl/maps/mr6Mk1gLTvdQS64d7"
            target="_blank"
            style="color: black"
          >
            <span class="d-block title-app"
              >Facebook / chapterbrandingstudio</span
            >
          </a>
        </div>

        <div
          v-bind:class="{
            'opacity-class': chapterCopy == false,
            animation: chapterCopy,
          }"
          style="animation-delay: 0.5s"
          class="my-6"
        >
          <div
            class="title-app SctoGroteskAMedium hidden-md-and-up"
            id="chapterCopy"
          >
            &copy; {{ date }}
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "home",
  props: { showContent: { type: Number } },
  data: () => ({
    // opts: {
    //   start: 0,
    //   dir: "v",
    //   duration: 500,
    //   beforeChange: function (currentSlideEl, currenIndex, nextIndex) {},
    //   afterChange: function (currentSlideEl, currenIndex) {},
    // },
    resource: {
      resource: {
        path: "",
      },
    },
    indexSlider: [],
    video: true,
    heightVideo: 0,
    chapterCopy: true,
    homeImage: 0,
    cycleCarouselHome: true,
    showCarousel: true,
    number: 0
  }),
  computed: {
    date() {
      var dateToFormat = new Date();
      var year = dateToFormat.getFullYear();

      return year;
    },
  },
  watch: {
    showContent: function () {
      // alert(this.showContent);

      if (this.showContent == 1500) {
        for (let index = 0; index < this.indexSlider.length; index++) {
          this.indexSlider[index] = 0;
          this.$set(this.indexSlider, index, 0);
        }
      }
    },
  },
  created: function () {
    var aux = this;
    fetch(
      "https://www.chaptercms.actstudio.xyz/api/singletons/get/assetPrincipal?token=6f2367a659983f01bf66f378fcfcd3"
    )
      .then((data) => data.json())
      .then((data) => (aux.resource = data))
      .then(function (data) {
        var array = [];

        for (let index = 0; index < aux.resource.length; index++) {
          array.push(0);
        }

        aux.indexSlider = array;
      });
  },
  mounted: function () {
    this.$emit("update", 0);

    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

    var rightColumn = document.getElementById("right-column");
    rightColumn.addEventListener('scroll', this.activateDot);
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  methods: {
    onResize() {
      this.heightVideo = window.innerHeight;
    },
    moveNext() {
      this.$refs.homeScroll.$fullpage.moveNext(); //Move to the next page
    },
    nextItemCarousel: function (asset, imgGallery) {
      console.log(asset + " " + imgGallery);

      if (this.homeImage == asset && this.homeImage == imgGallery) {
        this.homeImage++;
      }
    },
    carouselNext: function (index, length, numero) {
      // alert(numero++);
      // const numero = this.indexSlider[index];
      numero++;
      if (this.indexSlider[index] == length - 1) {
        this.indexSlider[index] = 0;
        this.$set(this.indexSlider, index, 0);
      } else {
        this.$set(this.indexSlider, index, numero);
      }
    },
    activateDot: function () {
      var rightColumn = document.getElementById("right-column");
      var offset = rightColumn.scrollTop
      var number = offset / this.$vuetify.breakpoint.height
      var roundNumber = Math.floor(number)

      this.number = roundNumber
    },
    goToItem: function (i){
      var body = $('#right-column')
      body.animate(
        {
          scrollTop: $('#right-column').scrollTop() + $('.item-' + i).position().top
        },
        {
          duration: 1000,
          queue: false
        }
      )
    }
  },
};
</script>
